import React, { useEffect, useState } from 'react';
import { Loader2, Save } from 'lucide-react';
import { Card, CardContent } from '@/components/ui/card';
import { Button } from '@/components/ui/button';
import { Input } from '@/components/ui/input';
import { Textarea } from '@/components/ui/textarea';
import { Label } from '@/components/ui/label';
import { Switch } from '@/components/ui/switch';
import { toast } from 'sonner';
import api from '@/lib/api';

export default function AdminSettings() {
  const [settings, setSettings] = useState(null);
  const [saving, setSaving] = useState(false);

  useEffect(() => { api.get('/admin/settings').then((r) => setSettings(r.data || {})); }, []);

  const save = async () => {
    setSaving(true);
    try {
      await api.put('/admin/settings', settings);
      toast.success('Configurações salvas');
    } catch (e) {
      toast.error(e.response?.data?.detail || 'Erro');
    } finally {
      setSaving(false);
    }
  };

  if (!settings) return <div className="text-muted-foreground">Carregando…</div>;

  const set = (k, v) => setSettings({ ...settings, [k]: v });

  return (
    <div className="space-y-4">
      <div>
        <div className="font-display text-4xl text-white">CONFIGURAÇÕES</div>
        <p className="text-muted-foreground">Personalize o site e o comportamento da votação.</p>
      </div>
      <Card className="border border-border bg-card">
        <CardContent className="p-5 grid grid-cols-1 md:grid-cols-2 gap-4">
          <Field label="Nome do campeonato" value={settings.championship_name} onChange={(v) => set('championship_name', v)} />
          <Field label="Nome do Pub" value={settings.pub_name} onChange={(v) => set('pub_name', v)} />
          <Field label="Logo URL" value={settings.logo_url} onChange={(v) => set('logo_url', v)} />
          <Field label="Imagem de capa (hero)" value={settings.cover_image_url} onChange={(v) => set('cover_image_url', v)} />
          <div className="md:col-span-2">
            <Label>Texto da página inicial</Label>
            <Textarea rows={2} value={settings.home_text || ''} onChange={(e) => set('home_text', e.target.value)} className="mt-1" />
          </div>
          <div className="md:col-span-2">
            <Label>Texto do regulamento</Label>
            <Textarea rows={10} value={settings.regulation_text || ''} onChange={(e) => set('regulation_text', e.target.value)} className="mt-1 font-mono text-xs" />
          </div>
          <Field label="URL do PDF do Regulamento (link direto)" value={settings.regulation_pdf_url} onChange={(v) => set('regulation_pdf_url', v)} />
          <Field label="Instagram URL" value={settings.instagram_url} onChange={(v) => set('instagram_url', v)} />
          <Field label="Endereço do Pub" value={settings.address} onChange={(v) => set('address', v)} />
          <Field label="Hora padrão dos eventos" value={settings.default_event_time} onChange={(v) => set('default_event_time', v)} />
          <Field label="URL base pública (para QR Codes)" value={settings.public_base_url} onChange={(v) => set('public_base_url', v)} />
          <Field label="Cor principal" value={settings.primary_color} onChange={(v) => set('primary_color', v)} />
          <Field label="Cor secundária" value={settings.secondary_color} onChange={(v) => set('secondary_color', v)} />
          <Toggle label="Habilitar senha da noite" description="Permite que etapas exijam senha para votar." value={settings.enable_night_password} onChange={(v) => set('enable_night_password', v)} />
          <Toggle label="Mostrar ranking de repescagem" value={settings.show_repechage_ranking} onChange={(v) => set('show_repechage_ranking', v)} />
          <Toggle label="Exibir total de votos publicamente" value={settings.show_vote_totals_publicly} onChange={(v) => set('show_vote_totals_publicly', v)} />
        </CardContent>
      </Card>
      <div className="flex justify-end">
        <Button data-testid="settings-save" onClick={save} disabled={saving} className="bg-[var(--g66-amber)] text-black hover:bg-[var(--g66-amber-2)]">
          {saving ? <Loader2 className="w-4 h-4 animate-spin" /> : <><Save className="w-4 h-4 mr-1" /> Salvar</>}
        </Button>
      </div>
    </div>
  );
}

function Field({ label, value, onChange }) {
  return (
    <div>
      <Label>{label}</Label>
      <Input value={value || ''} onChange={(e) => onChange(e.target.value)} className="mt-1" />
    </div>
  );
}

function Toggle({ label, description, value, onChange }) {
  return (
    <div className="flex items-start gap-3 rounded-lg border border-border p-3">
      <Switch checked={!!value} onCheckedChange={onChange} />
      <div className="flex-1">
        <div className="text-sm text-white">{label}</div>
        {description && <div className="text-xs text-muted-foreground">{description}</div>}
      </div>
    </div>
  );
}
